export const JNTUK_API_Urls = {
  "Site-Map": "/site-maps",
  "School-SHSR-Home": "/school-shsr-home?populate=*",
  "School-SHSR-Health-Conference": "/school-shsr-health-conference?populate=*",
  "School-SHSR-Gallery": "/school-shsr-gallery?populate=*",
  "School-SHSR-EOHAS": "school-shsr-eohas?populate=*",
  "School-SHSR-Contact-Us": "/school-shsr-contact-us?populate=*",
  "School-SHSR-Faculties": "/school-shsr-faculties?populate=*&sort=createdAt:asc",

  "School-SREE-Home": "school-sree-home?populate=*",
  "School-SREE-Syllabus": "school-sree-syllabus?populate=*",
  "School-SREE-Research-Publication":
    "school-sree-research-and-publication?populate=*",
  "School-SREE-Gallery": "school-sree-gallery?populate=*",

  "School-SREE-Eligibility": "school-sree-eligibility?populate=*",
  "School-SREE-Course-Structure": "school-sree-course-structure?populate=*",
  "School-SREE-Contact-Us": "school-sree-contact-us?populate=*",
  "School-SREE-About-Course": "school-sree-about-course?populate=*",
  "School-SREE-Infra-Structure": "school-sree-infra-structure?populate=*",
  "School-SREE-Faculties": "/school-sree-faculties?populate=*&sort=createdAt:asc",

  SREE_Industry_Interaction: "school-sree-list-of-companies",
  SREE_Placements: "school-sree-placements",
  "School-SOA-Gallery": "/school-soa-galleries?populate=*",
  "School-SOA-Home": "/school-soa-home?populate=*",
  "School-SOA-Contact-Us": "/school-soa-contact-us?populate=*",
  "School-SOA-Faculties": "/school-soa-faculties?populate=*&sort=createdAt:asc",
  "School-SOA-About-Course": "/school-soa-about-course",
  "School-SOA-Bos": "/school-soa-bo",
  "School-SOA-Eligibility": "/school-soa-eligibility?populate=*",
  "School-SOA-Research-Publication": "/school-soa-research-publication",
  "School-SOA-Home-Page-Banner": "/school-soa-home-page-banner",
  "School-SOA-Syllabus": "school-soa-syllabus?populate=*",
  "School-SOA-MOU-Signed": "/school-soa-mou-signed?populate=*",
  "School-SOA-Internship-Opportunitie": "/school-soa-internship-opportunitie",
  "School-SOA-Infra-Structure": "school-soa-infra-structure?populate=*",
  "School-SOA-Campus-Placements": "/school-soa-campus-placement?populate=*",
  "School-SSIT-About-Us": "/school-ssit-about-us",
  "School-SSIT-Vision-and-Mission":
    "/school-ssit-vision-and-mission?populate=*",
  "School-SSIT-Course-Structure": "/school-ssit-course-structure?populate=*",
  "School-SSIT-BOS": "/school-ssit-bos?populate=*",
  "School-SSIT-Faculties": "/school-ssit-faculties?populate=*&sort=createdAt:asc",
  "School-SSIT-Contact-Us": "/school-ssit-contact?populate=*",
  "School-SSIT-Home": "/school-ssit-home",
  "School-SSIT-Home-Page-Banner": "/school-ssit-home-page-banner",
  "School-SSIT-Eligibility": "/school-ssit-eligibility?populate=*",
  "School-SSIT-Syllabus": "school-ssit-syllabus?populate=*",
  "School-SSIT-Infra-Structure": "/school-ssit-infrastructure?populate=*",
  "School-SSIT-M.Tech-Remote-Sensing":
    "/school-ssit-m-tech-remote-sensing?populate=*",
  "School-SSIT-Academic-Calendar": "/school-ssit-academic-calendar?populate=*",
  "School-SSIT-Timetables": "/school-ssit-timetable?populate=*",
  "School-SSIT-Case-Study-Focus": "/school-ssit-case-study-focus?populate=*",
  "School-SSIT-Advantage": "/school-ssit-ssit-advantage?populate=*",
  "School-SSIT-Research-Scholars": "/school-ssit-research-scholar?populate=*",
  "School-SSIT-Book-Chapter-Research-Publications":
    "/school-ssit-book-chapter-research-publications?populate=*",
  "School-SSIT-Journal/Conference-Publication":
    "/school-ssit-journal-conference-publications?populate=*",
  "School-SSIT-Faculty-Recharging-Strategies":
    "/school-ssit-faculty-recharging-stratege?populate=*",
  "School-SSIT-Particulars-of-Research-scholars":
    "/school-ssit-particulars-of-research-scholars?populate=*",
  "School-SNT-Gallery": "/school-snt-gallery?populate=*",
  "Workshop/Conference": "school-ssit-workshop-conference?populate=*",
  "School-SSIT-Gallery": "/school-ssit-galleries?populate=*",
  "School-SSIT-Equipment":"/school-ssit-infrastructure-equipments?populate=*",
  Downloads: "/school-ssit-download?populate=*",
  "School-SNT-BOS": "/school-snt-bos",
  "School-SNT-Course-Structure": "/school-snt-course-structure?populate=*",
  "School-SNT-Academic-Calendar": "/school-snt-academic-calendar?populate=*",
  "School-SNT-Contact-Us": "/school-snt-contact-us?populate=*",
  "School-SNT-Faculties": "/school-snt-faculties?populate=*&sort=createdAt:asc",
  "School-SNT-Timetables": "/school-snt-timetable?populate=*",
  "School-SNT-Research-and-Publications":
    "/school-snt-research-and-publication?populate=*",
  "School-SNT-Notifications-and-Tenders":
    "/school-snt-notifications-and-tender?populate=*",
  "School-SNT-Project-Opportunities":
    "/school-snt-project-opportunity?populate=*",
  "School-SNT-Sports-Activity": "/school-snt-sports-activity?populate=*",
  "School-SNT-Achievements": "/school-snt-achievement?populate=*",
  "School-SNT-Home-Page-Banner": "/school-snt-home-page-banner",
  "School-SNT-Home": "/school-snt-home?populate=*",
  "School-SNT-About-Course": "/school-snt-about-course",
  "School-SNT-Eligibility": "/school-snt-eligibility?populate=*",
  "School-SNT-Syllabus": "/school-snt-syllabus?populate=*",
  "School-SNT-Infra-Structure": "/school-snt-infrastructure?populate=*",
  "School-SNT-Campus-Placements": "/school-snt-campus-placements?populate=*",
  "School-SNT-Industry-Interaction": "/school-snt-industry-interactions",
  "School-SNT-Student-Activities": "/school-snt-student-activity?populate=*",
  "School-SNT-Papers-presented-in-Conferences":
    "/school-snt-papers-presented-in-conferences",
  "School-SMS-Home": "/school-sms-home?populate=*",
  "School-SMS-Programs": "/school-sms-program?populate=*",
  "School-SMS-Faculties": "/school-sms-faculties?populate=*&sort=createdAt:asc",
  "School-SMS-Course-Structure": "/school-sms-course-structure?populate=*",
  "School-SMS-Research-and-Publications":
    "/school-sms-reasearch-and-publication?populate=*",
  "School-SMS-Contact-Us": "/school-sms-contact-us?populate=*",
  "School-SMS-Achivements": "/school-sms-achivement?populate=*",
  "School-SMS-Notifications": "/school-sms-notification?populate=*",
  "School-SMS-Placements": "/school-sms-placement?populate=*",
  "School-SMS-Industry_Interaction": "/",
  "School-SMS-Home-Page-Banner": "/school-sms-home-page-banner",
  "School-SMS-About-Course": "/school-sms-about-course",
  "School-SMS-Eligibility": "/school-sms-eligibility?populate=*",
  "School-SMS-Syllabus": "/school-sms-syllabus?populate=*",
  "School-SMS-Infra-Structure": "school-sms-infra-structure?populate=*",
  "School-SMS-Alumni": "/school-sms-alumni?populate=*",
  "School-SMS-Forthcoming-Events": "/school-sms-forthcoming-event?populate=*",
  "School-SMS-Past-Events": "/school-sms-past-event?populate=*",
  "School-SMS-EVENTS-ATTENDED": "/school-sms-events-attendeds",
  "School-SOPST-Home": "/school-sopst-home?populate=*",
  Institutional_Body: "/institutional-body",
  JNTUK_Vision: "/jntuk-vision",
  About_JNTUK: "/about-jntuk?populate=*",

  Institutional_Body: "/institutional-body",
  JNTUK_Vision: "/jntuk-vision",
  SDD: "/sdd",
  SWOC: "/swoc",
  Chancellor: "/chancellor?populate=*",
  Vice_Chancellor: "/vice-chancellor?populate=*",
  Rector: "/rector?populate=*",
  Registrar: "/registrar?populate=*",
  OSD: "/osd?populate=*",
  Executive_Council: "/jntuk-executive-councils",
  Academic_Senate: "/jntuk-academic-senates",
  Board_of_Studies: "/jntuk-board-of-studies",
  Directorates: "/jntuk-directorates?populate=*",
  Special_Officers: "/jntuk-special-officers?populate=*",
  Infrastructure_and_Learning_Resources:
    "/jntuk-infrastructure-and-learning-resource",
  Methodology: "/methodology",
  Admissions: "/jntuk-admission",
  Teaching_Learning_Process: "/jntuk-teaching-learning-process",
  Student_Support_and_Progression: "/jntuk-student-support-and-progression",
  JNTUK_Contacts: "/jntuk-contact",
  Autonomous_Colleges: "/jntuk-autonomous-colleges",
  Governing_Hierarchy: "/jntuk-governing-hierarchy?populate=*",
  Research: "/research",
  Circular_Aspects: "/jntuk-circular-aspect",
  University_Gallery: "/university-galleries?populate=*",
  Convocations: "/jntuk-convocations?sort=Date_of_Convocation:asc&populate=*",
  JNTUK_PDF_Files_Uploads: "/jntuk-pdf-files-uploads",
  University_Examination_Fee_Structure: "/university-examination-fee-structure",
  Affiliated_Colleges_East_Godavari:
    "/affiliated-colleges?filters[College_Category][$contains]=Affiliated Colleges – East Godavari",
  Affiliated_Colleges_West_Godavari:
    "/affiliated-colleges?filters[College_Category][$contains]=Affiliated Colleges – West Godavari",
  Affiliated_Colleges_Guntur:
    "/affiliated-colleges?filters[College_Category][$contains]=Affiliated Colleges – Guntur",
  Affiliated_Colleges_Krishna:
    "/affiliated-colleges?filters[College_Category][$contains]=Affiliated Colleges – Krishna",
  Affiliated_Colleges_Prakasam:
    "/affiliated-colleges?filters[College_Category][$contains]=Affiliated Colleges – Prakasam",

  Live_Scrolling: "/live-scrollings?populate=*",
  University_Song: "/university-song?populate=*",
  Addl_Controller_of_Examinations:
    "/addl-controller-of-examinations?populate=*",
  Controller_of_Examination_UG: "/controller-of-examination-ug?populate=*",
  Controller_of_Examinations_PG_and_SDC:
    "/controller-of-examinations-pg-and-sdc?populate=*",
  Programmes_Offered: "/programmes-offereds",
  Home_Page_Banner: "/home-page-banners?populate=*",
  Under_Graduate: "/courses?filters[Degree][$contains]=Under Graduate",
  Post_Graduate: "/courses?filters[Degree][$contains]=Post Graduate",
  JNTUK_Directorates: "/jntuk-directorates?populate=*",
  JNTUK_DAP_Department:
    "/jntuk-dap-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DAA_Department:
    "/jntuk-dap-director-audit?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DE_Department:
    "/jntuk-dap-director-evaluation?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DA_Department:
    "/jntuk-dap-director-admission?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DIIIPT_Department:
    "/jntuk-diiitp-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DRD_Department:
    "/jntuk-drd-department?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_FDC_Department:
    "/jntuk-fdc-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DID_Department:
    "/jntuk-did-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_FUR_Department:
    "/jntuk-fur-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DIST_Department:
    "/jntuk-dist-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_SOMS_Department:
    "/jntuk-sms-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DIQACLC_Department:
    "/jntuk-diqaclc-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DEWG_Department:
    "/jntuk-dewg-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DBICS_Department:
    "/jntuk-dbics-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DODL_OLP_Department:
    "/jntuk-dodl-olp-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_DGCI_Department:
    "/jntuk-dgci-director?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_UCEK_Principal:
    "/jntuk-ucek-principal?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  JNTUK_UCEN_Principal:
    "/jntuk-ucen-principal?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image",
  notification: "/notifications?populate=*",
};

export const JNTUK_PDF_Links = {
  JNTU_Act_Link: "/uploads/JNTUACT_8fa174ad54.pdf",
  RTI_Act_Link: "/uploads/RTI_Information_b80fd5bb48.pdf",
  AICTE_Approvals: "/uploads/AICTE_Approvals_3028db5cfb.pdf",
  PCI_Approvals: "/uploads/PCI_Approval_817f71a467.pdf",
  JNTUK_NAAC_SSR_2023: "/uploads/JNTUKNAACSSR_2023_61a6c8b203.pdf",
  NIRF_Overall_Report_2023:
    "/uploads/Jawaharlal_Nehru_Technological_University_Kakinada_NIRF_OVERALL_e0e902f9b8.pdf",
  JNTUK_AQAR_2017_18: "/uploads/JNTUK_AQAR_2017_18_FINAL_d430c4ad91.pdf",
  NIRF_Overall_Report_2022:
    "/uploads/NIRF_OVERALL_DATA_JNTU_20220218_e910d16040.pdf",
  NAAC_Self_Study_Report_Feb_2017:
    "/uploads/NAAC_JNTU_KAKINADA_SELF_STUDY_REPORT_SSR_Feb_2017_3820479a3e.pdf",
  Annual_Quality_Assurance_Reports:
    "/uploads/JNTUK_AQAR_2019_20_4_003aa1362e.pdf",
  ARAQ_Of_Student_Satisfaction_Survey:
    "/uploads/JNTUK_student_satisfaction_survey_e84ee1cecc.pdf",
  National_Institutional_Rankings_Framework_2020:
    "/uploads/JNTUK_NIRF_Overall_data_2019_20_b12637205f.pdf",
  "2F_of_UGC": "/uploads/2f_of_UGC_4c14d4b3fe.pdf",
  JNTUK_MALPRACTICE_GUIDELINES:
    "/uploads/JNTUK_Malpractices_guidelines_0bc4147844.pdf",
  PHD_AWARDEES_LIST_2016_2019:
    "/uploads/1575382865014_Ph_D_Awardees_2016_2019_b3fc9c2ba6.pdf",
  "12B_of_UGC": "/uploads/12_B_of_UGC_f8add22004.pdf",
  IT_Policies:
    "/uploads/JNTUK_IT_policies_and_procedures_Manual_with_images_af5cbdbe06.pdf",
  Sexual_Harassment_Committees: "/uploads/20230426105917_9e1e12a2aa.pdf",
  Placements_Graph: "/uploads/Placement_graph_315abed287.pdf",
  Visits_to_Industry: "/uploads/Visit_to_Coromandel_21accd4f09.pdf",
  Lab_Openings: "/uploads/Lab_Openings_4310d2e055.pdf",
  Skill_Development_Programmes:
    "/uploads/Summer_Internship_Program_Siemens_coe_0a3d81f4a6.pdf",
};
